// extracted by mini-css-extract-plugin
export default {"container":"Containers_container__2P39t"};